module.exports = __webpack_public_path__ + "ionicons.2c2ae068be3b089e0a5b.eot";


//////////////////
// WEBPACK FOOTER
// E:/Release/InzuzoA/InzuzoA/fonts/ionicons.eot?v=2.0.0
// module id = ../../../../../fonts/ionicons.eot?v=2.0.0
// module chunks = styles